import React, { PureComponent } from "react";
import { Col } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import PropTypes from "prop-types";
import renderSelectField from "../../../../shared/components/form/Select";
import * as configs from "./config";

class HorizontalForm extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  state = {
    inputs: configs.columnHeader,
    types: configs.yeNo,
  };

  componentDidMount() {
    this.props.initialize(this.props.edit());
    this.setState(this.props.edit());
    this.useCaseRef = React.createRef();
    this.tagRef = React.createRef();

    this.props.handleForm(this.props.edit());
  }

  cancelCreation = () => {
    this.props.reset();
    this.props.cancelCreation();
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  formChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    this.setState({ [nam]: val }, () => {
      this.props.handleForm(this.state);
    });
  };

  formDedicatedAccountManagerHandler = (event) => {
    this.setState({ dedicated_account_manager: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formOver100CountriesHandler = (event) => {
    this.setState({ over_100_countries: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formResidentialStaticHandler = (event) => {
    this.setState({ residential_static: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  formResidentialRotatingHandler = (event) => {
    this.setState({ residential_rotating: event.value }, () => {
      this.props.handleForm(this.state);
    });
  };

  printInput = (input) => {
    switch (input.key) {
      case "dedicated_account_manager":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.state.types}
            onChange={this.formDedicatedAccountManagerHandler}
          />
        );
      case "over_100_countries":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.state.types}
            onChange={this.formOver100CountriesHandler}
          />
        );
      case "residential_static":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.state.types}
            onChange={this.formResidentialStaticHandler}
          />
        );
      case "residential_rotating":
        return (
          <Field
            name={input.key}
            component={renderSelectField}
            options={this.state.types}
            onChange={this.formResidentialRotatingHandler}
          />
        );
      default:
        return (
          <Field
            name={input.key}
            component="input"
            type="text"
            placeholder={input.name}
            onKeyUp={this.formChangeHandler}
            value={this.state[input.key]}
          />
        );
    }
  };

  render() {
    const { handleSubmit } = this.props;

    return (
      <Col md={12} lg={12}>
        <div className="card__title">
          <h5 className="bold-text">{this.props.title}</h5>
        </div>
        <form
          autoComplete="off"
          className="form form--horizontal"
          onSubmit={handleSubmit}
        >
          {this.state.inputs.map(
            (input) =>
              !input.system &&
              (this.props.edit().slug === undefined ||
                (this.props.edit().slug !== undefined &&
                  input.key !== "slug")) && (
                <div className="form__form-group">
                  <span className="form__form-group-label">{input.name}</span>
                  <div className="form__form-group-field">
                    {this.printInput(input)}
                  </div>
                </div>
              )
          )}
        </form>
      </Col>
    );
  }
}

export default reduxForm({
  form: "add_residential_proxy_form", // a unique identifier for this form
})(HorizontalForm);
